export const DEFAULT_US_SCALE = 940;
export const DEFAULT_WORLD_SCALE = 130;

export const MAP_WIDTH = 700;
export const MAP_HEIGHT = 455;
